module.exports = __webpack_public_path__ + "static/media/jessie.8d126400.jpg";